/* eslint-disable @typescript-eslint/naming-convention */
export const DoorType = {
  COVER: 0, // Cửa phủ bì
  INNER: 1, // Cửa lọt lòng
  SLIDING: 2, // Cửa lùa
};

export const TypeCabinet = {
  KITCHEN: 'kitchen',
  WARDROBE: 'wardrobe',
  SHOE: 'shoe',
  TV: 'tv',
  BED: 'bed',
  DECORATIVE: 'decorative',
  VANITY: 'vanity',
  DESK: 'desk',
};

export const ModuleType = {
  CABINET: 30, // Tủ
  COUNTERTOP: 31, // Mặt bếp
  BACKSPLASH: 32, // Vách bếp
  LED_DECOR: 33, // Đèn led trang trí ở bếp
};

export const InsideType = {
  HPANEL: 0, // Xan ngang
  VPANEL: 1, // Xan dọc
  DRAWER: 3, // Hộc kéo
  U_DRAWER: 4, // Hộc kéo chữ U
  VCURVE: 5, // Xan dọc bo cong
  ACCESSORY_GENERAL: 6, // Phụ kiện dao thớt
  ACCESSORY_DISH_UPPER: 7, // Phụ kiện kệ chén bếp trên
  ACCESSORY_DISH_LOWER: 13, // Phụ kiện kệ chén bếp dưới
  DOOR: 8, // Cửa tủ
  BRACE: 9, // Bạ tủ
  HANDLE: 10, // Tay nắm
  VPANEL2: 11, // Xan dọc tách 2
  CLOTHES_HANGER: 12, // Thanh treo quần áo
  ACCESSORY_SINK: 14, //Bồn rửa
  ACCESSORY_FRIDGE: 15, //tủ lạnh
  ACCESSORY_COOKER: 16, //bếp từ
  ACCESSORY_HOOD: 17, //Máy hút mùi
  ACCESSORY_FAUCET: 18, //vòi rửa
  HPANEL_RIGHT: 19, //XAN NGANG bo cong phải
  COL_PANEL: 20, // Bìa cột
  ACCESSORY_WASHER: 21, // máy rửa chén
  HPANEL_LEFT: 22, //XAN NGANG  bo cong trái

  HPANEL_SHOE: 23, // Xắn ngang tủ giày
  ACCESSORY_FLIP: 24, // Phụ kiện lật tủ giày
  MIRROR_DOOR: 25, // Gương gắn sau cửa tủ

  KHUNG_SAT: 26, // Chân khung sắt
  CHAN_ROI_TV: 27, // Chân rời
  LOCK: 28, // Ổ khóa cửa
  LIFT_SUPPORT: 29, // Tay nâng, ti hơi

  BED_SLAT: 30,

  LED_RECESSED: 40, // Led âm
  LED_CORNER: 41, // Led góc

  DOOR_TEMPLATE: 88, // Cửa tủ template
  MESH_TEMPLATE: 89, // Mesh template để scale những MB,VB,Nẹp nóc đặc biệt
  STOOL_CUSHION: 90, // Nệm ngồi ở đôn ngồi
  LED_EFFECT: 91, // Hiệu ứng của đèn led
  DOOR_CLONE: 92, // Cửa clone để rescale tránh ảnh hưởng cửa chính
};

export const CutPosition = {
  TOP: 1,
  BOTTOM: 2,
  LEFT: 3,
  RIGHT: 4,
};

export const CabinetTrimPos = {
  TOP: 1,
  LEFT: 2,
  RIGHT: 3,
  BACK: 4,
  LEFTMOST: 5,
  RIGHTMOST: 6,
};

export const CabinetCoverPos = {
  LEFT: 1,
  RIGHT: 2,
};

export const PointSnapPos = {
  TOP: 1,
  CENTER: 2,
  BOTTOM: 3,
};

export const SnapDoor = {
  MIN_DISTANCE: 0.2,
  MAX_DISTANCE: 0.4,
};

export const LimitDoor = {
  WIDTH: 0.6,
};

export const CeilingDoor = {
  WITH_BRACE: 'co_ba',
  WITHOUT_BRACE: 'khong_ba',
};

export const DoorDirection = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const HorizontalType = {
  LIM_HEIGHT: 0.4,
  ONE_D: '1canh',
  TWO_D: '2canh',
};

export const TypeConnerModule = {
  MAIN: 'MAIN',
  SUB: 'SUB',
};

/**
 * Định nghĩa shape types đơn giản
 */
export const SHAPE_TYPES = {
  BOX: 'box', // Hình hộp thường (default)
  L_SHAPE: 'l_shape', // Hình chữ L
  T_SHAPE: 't_shape', // Hình chữ T
  U_SHAPE: 'u_shape', // Hình chữ U
};

export const BACK_THICKNESS_OPTIONS = [
  { label: '8 mm', value: 8 },
  { label: '17 mm', value: 17 },
];
